export type Flavor = {
    name: string;
    color: string;
    light: boolean;
};

export const doughs: Flavor[] = [
    { name: 'Pão de Ló', color: '#F3D48A', light: true },
    { name: 'Red Velvet', color: '#9B3040', light: false },
    { name: 'Chocolate', color: '#4A2C24', light: false },
    { name: 'Noz', color: '#A67C52', light: false },
    { name: 'Massa Folhada', color: '#E7D3A1', light: true },
    { name: 'Laranja', color: '#E07A2F', light: false },
    { name: 'Cenoura', color: '#E08A3C', light: false },
    { name: 'Iogurte', color: '#F6F1E8', light: true },
];

export const frostings: Flavor[] = [
    { name: 'Mousse de Baunilha', color: '#F6E7C1', light: true },
    { name: 'Mousse de Oreo', color: '#3A3A3A', light: false },
    { name: 'Mousse de Kinder', color: '#C4A574', light: true },
    { name: 'Recheio de Caramelo', color: '#C68642', light: false },
    { name: 'Recheio de Brigadeiro Negro', color: '#4A2C24', light: false },
    { name: 'Recheio de Brigadeiro Branco', color: '#F3E6D0', light: true },
    { name: 'Recheio de Cafe', color: '#6F4E37', light: false },
    { name: 'Recheio de Brigadeiro Coco', color: '#F7F3EA', light: true },
    { name: 'Recheio de Morango', color: '#D4536A', light: false },
    { name: 'Recheio de Frutos Vermelhos', color: '#8E3A4B', light: false },
    { name: 'Recheio de Fruta Variada', color: '#E07A4A', light: false },
    { name: 'Recheio de Queijo Creme', color: '#F4EFE4', light: true },
    { name: 'Recheio de Creme Ovos', color: '#F0C14A', light: true },
    { name: 'Mousse de Limão', color: '#E6D35A', light: true },
];
